export class NotTheSameOriginError extends Error {
  constructor() {
    super("the URL isn't within the same origin");
  }
}